import React from 'react'

import { ISSUE_LINK_SYSTEM_TYPE } from '../../constants'
import ToirIssueLinkInfoblock from './ToirIssueLinkInfoblock'
import EsuzIssueLinkInfoblock from './EsuzIssueLinkInfoblock'

export const IssueLinkInfoblock = ({
  issueLink,
  issueLinkSystemType,
}) => (
  <React.Fragment>
    {
      issueLinkSystemType === ISSUE_LINK_SYSTEM_TYPE.toir
        ? <ToirIssueLinkInfoblock issueLink={issueLink} />
        : null
    }
    {
      issueLinkSystemType === ISSUE_LINK_SYSTEM_TYPE.ahp
        ? <EsuzIssueLinkInfoblock issueLink={issueLink} />
        : null
    }
  </React.Fragment>
)
